import URLS from '../config/urls';
import BaseAPI from './BaseApi';

class OrderApi {
    async getList(params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ORDERS}/custom/search`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async getListByCustomer(uuidCustomer: string, params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ORDERS}/customers/${uuidCustomer}`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async getOrder(uuidOrder: string, uuidCustomer: string): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ORDERS}/${uuidOrder}/customers/${uuidCustomer}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer detalhes do pedido" }; // Retorna um objeto de erro
        }
    }

    async getOrderBonus(uuidOrder: string, uuidCustomer: string): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ORDERS}/${uuidOrder}/bonus`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer detalhes do pedido" }; // Retorna um objeto de erro
        }
    }

    async changeOrderStatus(newStatusName: string, uuidOrder: string, uuidCustomer: string): Promise<any> {
        const payload = {
            statusName: newStatusName
        };

        try {
            const response = await BaseAPI.put(`${URLS.ORDERS}/${uuidOrder}/status/customers/${uuidCustomer}`, payload);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao alterar status" }; // Retorna um objeto de erro
        }
    }
}

const orderApi = new OrderApi();
export default orderApi;